// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-menu-item-im {\n  cursor: pointer;\n}\n.right-menu-item-im .el-badge__content.is-fixed {\n    top: 6px !important;\n    right: 20px !important;\n}\n.communicate .el-badge__content.is-fixed {\n  top: 5px !important;\n  right: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
